// 本地环境配置
export default {
  bucketName: 'dev-ubq',
  cdnUrl: 'https://obs.dev.ubanquan.cn',
  // 优版权obs cdn
  cdnMLMUrl: '',
  // 漫联盟obs cdn
  cdnBWLUrl: ''
};